export function getImdbHref(person) {
  if (person.imdb) {
    return person.imdb;
  }

  return `https://www.imdb.com/find/?q=${encodeURIComponent(person.name)}&s=nm`;
}
